import { useEffect, useRef } from 'react'

import { runStatsigTriggeredSessionReplay, startRecording, stopRecording } from '@statsig/session-replay'

type StatsigClientArg = Parameters<typeof runStatsigTriggeredSessionReplay>[0]

interface Params {
  client: StatsigClientArg | null
  enabled: boolean
  clientKey: string
}

export const useSessionReplay = ({ client, enabled, clientKey }: Params): void => {
  const replayRegistered = useRef(false)

  useEffect(() => {
    if (!enabled || !client) return undefined

    const syncRecording = (): void => {
      if (window.Cookiebot?.consent?.statistics) {
        if (!replayRegistered.current) {
          runStatsigTriggeredSessionReplay(client, { rrwebConfig: { maskAllInputs: true } })
          replayRegistered.current = true
        }
        startRecording(clientKey)
      } else if (replayRegistered.current) {
        stopRecording(clientKey)
      }
    }

    syncRecording()

    window.addEventListener('CookiebotOnConsentReady', syncRecording)

    return () => window.removeEventListener('CookiebotOnConsentReady', syncRecording)
  }, [enabled, client, clientKey])
}
